export class BaseModMod {
  MOD_MOD_ISN: number;
  MOD: string;
  MOD_TYPE: string;
  MOD_TYPE_NAME: string;
  ABREVIATION: string;
  MOD_NBR: string;
  MOD_NBR_WITH_TYPE: string;
  MOD_REV: string;
  ALT_KEY: string;
  INFO_KEY: string;
  MOD_PARENT: string;
  OWNER: string;
  STATUS: string;
  STATUS_NAME: string;
  PCC_NBR: string;
  WO_NBR: string;
  FAA_DTE: Date;
  CALC_MOD_ORIG_RLSE_DTE: Date;
  RLSE_DTE_ORIG: Date;
  RLSE_DTE_MATL: Date;
  RLSE_DTE_SCHD_CNTL: string;
  MATL_ETA: number;
  EST_MATL_COST: number;
  EST_MHRS_SHOP: number;
  EST_MACH_MHRS: string;
  EST_MHRS_ACN: number;
  HRLY_RATE: number;
  WT_CHG: string;
  WT_CHG_AMT: string;
  WT_CHG_LOC: string;
  SORT_FLD: string;
  KIT: string;
  SUBSQ: string;
  REPET: string;
  MOD_REPET: number;
  RETRO: string;
  SHOP: string;
  VENDOR: string;
  ATA: string;
  ATA_CHAPTER: string;
  ATA_SUBCHAPTER: string;
  PCI_RCN: string;
  LEGAL: string;
  CLSE_DTE: Date;
  AUTHOR: string;
  FILM_ROLL: string;
  TRACK: string;
  SPEC_LIMITED: string;
  USER_FIELD: string;
  EFF_DTE: Date;
  REV_DTE: Date;
  ENGINEER: string;
  PLANNER: string;
  MAJ_MIN: string;
  PRIORITY: string;
  SCHD_IND1: string;
  SCHD_IND2: string;
  SCHD_IND3: string;
  SCHD_IND4: string;
  APPL_CODE: string;
  TRANS_NAME: string;
  INTENT_CODE: string;
  TRANS_TM: Date;
  TRANS_USER_ID: string;
  TERMINAL_ID: string;
  CONSTRUCT_TIME: string;
  MODULE_NAME: string;
  CHG_TO_CPN: string;
  CHG_FROM_CPN: string;
  OBSOLESENCE_EO_FLAG: string;
  EO_TEXT_KEY: number;
  FLEET_IND: string;
  ADD_TM: Date;
  ADD_USER_ID: string;
  AD_ALERT: string;
  AD_ALERT_IND: number;
  EWIS_IND: string;
  CATEGORY_IND: string;
  AUDITOR_EMP_ID: string;
  COMPLIANCE: string;
  ENGINEER_EMP_ID: string;
  PLANNER_EMP_ID: string;
  VERSION_NBR: number;
  LINE_MX_NBR: number;
  MOD_CAP_PROJ: string;
  CAP_PROJ_IND: number;
  CAP_PROJ_COUNT: number;
  MOD_COMPLIANCE_CODE: string;
  MOD_COMPLIANCE_DESC: string;
  MOD_MAJ_MIN_CODE: string;
  MOD_MAJ_MIN_DESC: string;
  MOD_PRIORITY_CODE: string;
  MOD_PRIORITY_DESC: string;
  OPTIX_OBJ_ID: number;
  ADAPT_TITLE: string;
  ADAPT_CLASSIFICATION: string;
  ADAPT_ATA_CHAP: string;
  ADAPT_ATA_SUBCHAP: string;
  ADAPT_RELEASE_BY: string;
  ADAPT_RELEASE_DTE: string;
}
